import { Component, OnInit, Input, EventEmitter, ChangeDetectorRef, Output, ViewChild } from '@angular/core';
import { Global } from "../../classes/global";
import { SaleRecordService } from "../../services/saleRecord/sale-record.service";
import { UserService } from "../../services/user/user.service";
import { ToastrService } from "ngx-toastr";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-merge-orders',
  templateUrl: './merge-orders.component.html',
  styleUrls: ['./merge-orders.component.scss']
})
export class MergeOrdersComponent implements OnInit {

  @Input() saleRecord: any;
  @Input() mergeSuggestions: any[] = [];
  @Output() mergeOrderDone: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('mergeOrdersModal', { static: false })
  private mergeOrdersModal: NgbModalRef;

  modalResult: any;
  selectedOrderToMerge: any = null;
  availableOrders: any[] = [];
  searchQuery: string = '';
  isLoading: boolean = false;
  private searchSubject = new Subject<string>();

  constructor(public global: Global,
    private saleRecordService: SaleRecordService,
    private toastr: ToastrService,
    private userService: UserService,
    private changeDetectorRef: ChangeDetectorRef,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    // Set up debounced search
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchQuery => {
      if (searchQuery && searchQuery.length >= 2) {
        this.searchOrders(searchQuery);
      } else {
        this.availableOrders = [];
      }
    });
  }

  openMergeOrdersModal() {
    this.modalResult = this.modalService.open(this.mergeOrdersModal, { size: 'lg' });
    this.selectedOrderToMerge = null;
    this.searchQuery = '';
    
    // Load suggestions if available, otherwise keep search functionality
    if (this.mergeSuggestions && this.mergeSuggestions.length > 0) {
      this.availableOrders = this.mergeSuggestions.map(order => ({
        ...order,
        displayText: `${order.sourceOrderId} - ${order.customerName} - ${this.getCustomerAddress(order.customerAddress)}`
      }));
    } else {
      this.availableOrders = [];
    }
  }

  onSearchInput(event: any) {
    const searchQuery = event.term || event;
    console.log('Search input:', searchQuery);
    this.searchQuery = searchQuery;
    
    // If we have suggestions, filter them locally, otherwise search on server
    if (this.mergeSuggestions && this.mergeSuggestions.length > 0) {
      this.filterSuggestions(searchQuery);
    } else {
      this.searchSubject.next(searchQuery);
    }
  }

  filterSuggestions(searchQuery: string) {
    if (!searchQuery || searchQuery.length < 2) {
      this.availableOrders = this.mergeSuggestions.map(order => ({
        ...order,
        displayText: `${order.sourceOrderId} - ${order.customerName} - ${this.getCustomerAddress(order.customerAddress)}`
      }));
      return;
    }

    const query = searchQuery.toLowerCase();
    this.availableOrders = this.mergeSuggestions
      .filter(order => 
        order.sourceOrderId.toLowerCase().includes(query) ||
        order.customerName.toLowerCase().includes(query) ||
        order.productName.toLowerCase().includes(query) ||
        order.sku.toLowerCase().includes(query)
      )
      .map(order => ({
        ...order,
        displayText: `${order.sourceOrderId} - ${order.customerName} - ${this.getCustomerAddress(order.customerAddress)}`
      }));
  }

  searchOrders(searchQuery: string) {
    console.log('searchOrders called with:', searchQuery);
    this.isLoading = true;
    this.saleRecordService.getOrdersForMerge(searchQuery, this.saleRecord.sourceOrderId)
      .subscribe((data) => {
        console.log('Search results:', data);
        this.isLoading = false;
        this.availableOrders = data.map(order => ({
          ...order,
          displayText: `${order.sourceOrderId} - ${order.customerName} - ${this.getCustomerAddress(order.customerAddress)}`
        }));
      }, (error) => {
        console.error('Search error:', error);
        this.isLoading = false;
        this.toastr.error('Lỗi khi tìm kiếm đơn hàng');
      });
  }


  onOrderSelected(selectedOrder: any) {
    if (selectedOrder) {
      this.selectedOrderToMerge = this.availableOrders.find(order => order.orderItemId === selectedOrder.orderItemId);
    } else {
      this.selectedOrderToMerge = null;
    }
  }

  confirmMerge() {
    if (!this.selectedOrderToMerge) {
      this.toastr.warning('Vui lòng chọn đơn hàng để gộp');
      return;
    }

    this.global.pageLoading = true;
    this.saleRecordService.mergeOrders(this.saleRecord.orderItemId, this.selectedOrderToMerge.orderItemId)
      .subscribe((data) => {
        this.global.pageLoading = false;
        this.toastr.success('Đơn hàng đã được gộp thành công');
        this.mergeOrderDone.emit('');
        this.modalResult.close();
      });
  }

  closeModal() {
    this.modalResult.close();
  }

  getCustomerAddress(order: any): string {
    if (!order) return '';
    
    let address = '';
    if (order.streetAddress) address += order.streetAddress;
    if (order.streetAddress2) address += ', ' + order.streetAddress2;
    if (order.city) address += ', ' + order.city;
    if (order.state) address += ', ' + order.state;
    if (order.zipCode) address += ' ' + order.zipCode;
    if (order.channel) address += ', ' + order.channel;
    
    return address.trim();
  }
}
